import React from "react";

const ProgressOverviewSkeleton: React.FC = () => {
  return (
    <div className="grid gap-6 rounded-xl border border-slate-200 bg-slate-50 p-5 md:grid-cols-[1.4fr_1fr]">
      <div>
        <div className="mb-3 h-6 w-64 rounded bg-slate-200 animate-pulse" />

        <div className="flex gap-10">
          <div>
            <div className="h-10 w-16 rounded bg-slate-200 animate-pulse" />
            <div className="mt-1 h-4 w-28 rounded bg-slate-200 animate-pulse" />
          </div>
          <div>
            <div className="h-10 w-16 rounded bg-slate-200 animate-pulse" />
            <div className="mt-1 h-4 w-32 rounded bg-slate-200 animate-pulse" />
          </div>
          <div>
            <div className="h-10 w-16 rounded bg-slate-200 animate-pulse" />
            <div className="mt-1 h-4 w-40 rounded bg-slate-200 animate-pulse" />
          </div>
        </div>

        <div className="mt-5 grid max-w-xl gap-5">
          <div className="w-full">
            <div className="h-3 w-full rounded-full bg-slate-200 animate-pulse" />
            <div className="mt-2 h-4 w-40 rounded bg-slate-200 animate-pulse" />
          </div>
          <div className="w-full">
            <div className="h-3 w-full rounded-full bg-slate-200 animate-pulse" />
            <div className="mt-2 h-4 w-36 rounded bg-slate-200 animate-pulse" />
          </div>
          <div className="w-full">
            <div className="h-3 w-full rounded-full bg-slate-200 animate-pulse" />
            <div className="mt-2 h-4 w-56 rounded bg-slate-200 animate-pulse" />
          </div>
        </div>
      </div>

      <div className="grid justify-items-center">
        <div className="h-6 w-48 rounded bg-slate-200 animate-pulse" />
        <div className="mt-2 h-40 w-40 rounded-full bg-slate-200 animate-pulse" />
      </div>
    </div>
  );
};

export default ProgressOverviewSkeleton;


